import loanEligibilty from '../api/loanEligibility';
import createDataContext from './createDataContext';
import { toast } from 'react-toastify';
import { loanSchema } from '../helpers/validator';

const GET_MONO_CONNECT_KEY = 'GET_MONO_CONNECT_KEY';
const GET_EXCHANGE_TOKEN = 'GET_EXCHANGE_TOKEN';
const GET_STATEMENT = 'GET_STATEMENT';
const VERIFY_IDENTITY = 'VERIFY_IDENTITY';
const AUTH_AND_GET_LOAN_STATUS = 'AUTH_AND_GET_LOAN_STATUS';
const SET_VALUE = 'SET_VALUE';

const initialState = {
  monoConnectKey: '',
  monoId: '',
  userName: 'Stranger',
  userData: {},
  statement: '',
  statementRecieved: false,
  exchangeTokenId: '',
  identity: {},
  monoAuthStatus: false,
  identityVerified: false,
  values: { amountToBorrow: 0, yearsInmonths: 0, interest: 8 },
};

const setValues = (dispatch) => (field, value) => {
  dispatch({ type: SET_VALUE, payload: { field, value } });
};
const getMonoConnectKey = (dispatch) => (key) => {
  dispatch({ type: GET_MONO_CONNECT_KEY, payload: key });
};

const getExchangeToken = (dispatch) => async (
  values,
  monoId,
  setFirstBtnLoading
) => {
  console.log({ values });

  const valid = await loanSchema.isValid(values);
  console.log({ valid });
  try {
    setFirstBtnLoading(true);
    let result = await loanEligibilty.post('/authWithMono2', {
      monoId,
    });
    console.log({ result });
    toast.success('Authentication successful!');
    setFirstBtnLoading(false);
    dispatch({ type: AUTH_AND_GET_LOAN_STATUS, payload: result.data });
  } catch (err) {
    console.log({ err });
    toast.error('Oop, something went wrong!');
    setFirstBtnLoading(false);
  }
};

const verifyIdentity = (dispatch) => async (exchangeTokenId) => {
  try {
    let result = await loanEligibilty.get('/verifyIdentity', {
      params: { id: exchangeTokenId },
    });
    console.log({ result });
    dispatch({ type: VERIFY_IDENTITY, payload: result.data.identity });
    toast.success("Wohooo you're verified! You can make your request now.");
  } catch (err) {
    console.log({ err });
    toast.error('Oop, something went wrong');
  }
};

const requestEligibiltyStatus = (dispatch) => async (
  values,
  setThirdBtnLoading
) => {
  try {
    let result = await loanEligibilty.post('/loans', values);

    if (result.data.status === 'success') {
      console.log({ result });
      setThirdBtnLoading(false);
      toast.success(result.data.message, {
        autoClose: 15000,
      });
      dispatch({
        type: GET_STATEMENT,
        payload: result.data.data.payablePerMonth,
      });
    } else {
      setThirdBtnLoading(false);
      toast.error(result.data.message, {
        autoClose: 15000,
      });
    }
  } catch (error) {
    console.log({ error });
    toast.error('Something went wrong. Please try again later!');
  }
};

const loanReducer = (state, action) => {
  switch (action.type) {
    case GET_MONO_CONNECT_KEY:
      return { ...state, monoConnectKey: action.payload };
    case GET_EXCHANGE_TOKEN:
      return {
        ...state,
        exchangeTokenId: action.payload,
        monoAuthStatus: true,
      };
    case AUTH_AND_GET_LOAN_STATUS:
      return {
        ...state,
        monoAuthStatus: true,
        userData: action.payload,
      };
    case SET_VALUE:
      return {
        ...state,
        values: {
          ...state.values,
          [action.payload.field]: action.payload.value,
        },
      };
    case GET_STATEMENT:
      return { ...state, statement: action.payload, statementRecieved: true };
    case VERIFY_IDENTITY:
      return {
        ...state,
        identity: action.payload,
        userName: `${action.payload.firstName} ${action.payload.lastName}`,
        identityVerified: true,
      };
    default:
      return state;
  }
};

export const { Provider, Context } = createDataContext(
  loanReducer,
  {
    getMonoConnectKey,
    getExchangeToken,
    requestEligibiltyStatus,
    verifyIdentity,
    setValues,
  },
  initialState
);
